/**
 * Media mit Text Slider
 * DSS - DeSight Shopify Theme
 */

import { $, $$, debounce } from '../utils/helpers.js';

class MediaWithTextSlider {
  constructor(containerId) {
    this.containerId = containerId;
    this.slider = $(`.media-with-text__slider--${containerId}`) || $(`[data-mwt-slider-id="${containerId}"]`);
    this.track = this.slider?.querySelector('.media-with-text__slider-track');
    this.slides = this.slider ? Array.from(this.slider.querySelectorAll('.media-with-text__slide')) : [];
    this.prevBtn = $(`[data-mwt-prev="${containerId}"]`);
    this.nextBtn = $(`[data-mwt-next="${containerId}"]`);
    this.pagination = $(`[data-mwt-pagination="${containerId}"]`);
    this.dots = this.pagination ? Array.from(this.pagination.querySelectorAll('.media-with-text__pagination-dot')) : [];

    this.currentIndex = 0;
    this.maxIndex = Math.max(0, this.slides.length - 1);
    this.autoplayInterval = null;
    this.autoplayDelay = 0;
    this.isTransitioning = false;

    if (!this.slider || !this.track || this.slides.length <= 1) return;

    this.init();
  }

  init() {
    this.bindEvents();
    this.updateButtons();

    window.addEventListener('resize', debounce(() => this.updatePosition(), 150));
  }

  updatePosition() {
    if (this.isTransitioning || this.slides.length === 0) return;

    this.isTransitioning = true;
    const offset = this.currentIndex * 100;
    this.track.style.transform = `translateX(-${offset}%)`;

    setTimeout(() => {
      this.isTransitioning = false;
    }, 400);

    this.updatePagination();
    this.updateButtons();
  }

  bindEvents() {
    if (this.prevBtn) {
      this.prevBtn.addEventListener('click', () => this.prev());
    }

    if (this.nextBtn) {
      this.nextBtn.addEventListener('click', () => this.next());
    }

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const index = parseInt(dot.dataset.mwtIndex, 10);
        this.goToSlide(index);
      });
    });

    let touchStartX = 0;
    let touchEndX = 0;

    this.slider.addEventListener('touchstart', (e) => {
      touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    this.slider.addEventListener('touchend', (e) => {
      touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe(touchStartX, touchEndX);
    }, { passive: true });

    this.slider.addEventListener('mouseenter', () => this.stopAutoplay());
    this.slider.addEventListener('mouseleave', () => this.startAutoplay());
  }

  handleSwipe(startX, endX) {
    const threshold = 50;
    const diff = startX - endX;

    if (Math.abs(diff) > threshold) {
      if (diff > 0) {
        this.next();
      } else {
        this.prev();
      }
    }
  }

  next() {
    if (this.currentIndex < this.maxIndex) {
      this.currentIndex++;
      this.updatePosition();
    } else {
      this.currentIndex = 0;
      this.updatePosition();
    }
  }

  prev() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.updatePosition();
    } else {
      this.currentIndex = this.maxIndex;
      this.updatePosition();
    }
  }

  goToSlide(index) {
    if (index >= 0 && index <= this.maxIndex) {
      this.currentIndex = index;
      this.updatePosition();
    }
  }

  updateButtons() {
    if (this.prevBtn) {
      this.prevBtn.disabled = this.currentIndex === 0;
    }

    if (this.nextBtn) {
      this.nextBtn.disabled = this.currentIndex >= this.maxIndex;
    }
  }

  updatePagination() {
    if (!this.dots.length) return;

    this.dots.forEach((dot, index) => {
      if (index === this.currentIndex) {
        dot.classList.add('is-active');
      } else {
        dot.classList.remove('is-active');
      }
    });
  }

  startAutoplay() {
  }

  stopAutoplay() {
    if (this.autoplayInterval) {
      clearInterval(this.autoplayInterval);
      this.autoplayInterval = null;
    }
  }
}

function initMediaWithTextSliders() {
  const sliders = $$('[data-mwt-slider-id]');

  sliders.forEach(slider => {
    const id = slider.dataset.mwtSliderId;
    if (id) {
      new MediaWithTextSlider(id);
    }
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initMediaWithTextSliders);
} else {
  initMediaWithTextSliders();
}

document.addEventListener('shopify:section:load', (event) => {
  if (event.detail?.sectionId) {
    const slider = document.querySelector(`[data-mwt-slider-id="${event.detail.sectionId}"]`);
    if (slider) {
      new MediaWithTextSlider(event.detail.sectionId);
    }
  }
});

export { MediaWithTextSlider, initMediaWithTextSliders };
